import skinsEnCnMap from './skins-en-cn.json'

export const formatSkinName = (englishName: string, lang: string): string => {
  if (lang !== 'zh') {
    return englishName
  }
  const chineseName = skinsEnCnMap[englishName as keyof typeof skinsEnCnMap]
  return chineseName || englishName
}
